import { isAvailableFeatureSelector } from 'features/billing'

export const isContactDrawerOpenSelector = ({ contacts }) => contacts.isContactDrawerOpen

export const activeContactDrawerSelector = ({ contacts }) => contacts.activeContactDrawer

export const getCurrentContact = ({ contacts }) => contacts.currentContact

export const currentContactProfileSelector = ({ contacts }) => contacts.currentContactProfile

export const isShareAvailabilityFeatureEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'share_availability_from_contacts' }
)

export const getContactDrawerSource = ({ contacts }) => contacts.contactDrawerSource === 'calendly_assist'
